// Hover/focus tooltip (Radix). <Tooltip title="Text">{child}</Tooltip> — same shape as MUI's.
import { Tooltip as T } from "radix-ui";

export function Tooltip({ title, children, side = "top" }) {
  if (!title) return children;
  return (
    <T.Provider delayDuration={250}>
      <T.Root>
        <T.Trigger asChild>{children}</T.Trigger>
        <T.Portal>
          <T.Content side={side} sideOffset={6} className="z-[1500] max-w-xs rounded-md bg-fg px-2 py-1 text-[12px] text-white shadow-pop">
            {title}
          </T.Content>
        </T.Portal>
      </T.Root>
    </T.Provider>
  );
}
